import React, { useEffect, useState } from "react";
import classes from "./CountrySelect.module.scss";
import ReactSelect from "react-select";
import StateManager from "react-select";
import components from "./components";

import { IJobsSearchRegionFields } from "../../@types/contentful";
import { ICountryFields } from "../../@types/contentful";
import { useRefinementList } from "react-instantsearch";
import { useRef } from "react";

export interface Region {
  fields: IJobsSearchRegionFields;
}

export interface SelectProps {
  regions: Region[];
  placeholder: string;
  countries: ICountryFields[];
  [x: string]: any;
}

export const CountrySelect: React.FC<SelectProps> = ({
  children,
  onChange,
  placeholder,
  regions,
  countryNotSelected,
  countryNoResults,
  oneCountrySelected,
  manyCountriesSelected,
  countries,
  ...props
}) => {
  const countrySelectRef = useRef<StateManager>(null);

  const { canRefine, refine, items } = useRefinementList(
    {
      attribute: "country",
    },
    {
      $$widgetType: "ais.refinementList",
    }
  );
  const [selectedCountries, setSelectedCountries] = useState<string[]>(
    items.filter((item) => item.isRefined).map((item) => item.value)
  );

  useEffect(() => {
    setSelectedCountries(
      items.filter((item) => item.isRefined).map((item) => item.value)
    );
  }, [setSelectedCountries, items]);

  // const { location } = useHistory();
  const [countriesMap, setCountriesMap] = useState<Object>({});
  useEffect(() => {
    if (countries) {
      const map = {};
      countries.forEach((country) => {
        // @ts-ignore
        map[country.name as string] = country.tag as string;
      });
      setCountriesMap(map);
    }
  }, [countries]);

  useEffect(() => {
    if (canRefine && selectedCountries && regions) {
      const countries = regions
        .map((region) => region.fields?.countries)
        .flat();
      countrySelectRef.current?.select.setValue(
        // @ts-ignore
        countries.map((country) => ({
          label: country.fields?.label as string,
          value: country.fields?.name as string,
        })),
        "set-value"
      );
    }
  }, [regions, canRefine, selectedCountries, countrySelectRef]);

  const style = {
    control: (base: any) => ({
      ...base,
      boxShadow: "none",
    }),
  };

  const handleToggleCountry = (country: string) => {
    if (selectedCountries.includes(country)) {
      handleCountryRemove(country);
    } else {
      const countries = Array.from(new Set([country, ...selectedCountries]));
      setSelectedCountries(countries);
      refine(country);
    }
  };

  const handleCountryRemove = (country: string) => {
    const countries = selectedCountries.filter((e) => e !== country);
    setSelectedCountries(countries);
    refine(country);
  };
  return (
    <ReactSelect
      {...props}
      regions={regions}
      placeholderText={placeholder}
      countryNotSelected={countryNotSelected}
      countryNoResults={countryNoResults}
      oneCountrySelected={oneCountrySelected}
      manyCountriesSelected={manyCountriesSelected}
      selectedCountries={selectedCountries}
      ref={countrySelectRef}
      countrySelectRef={countrySelectRef}
      classNamePrefix="country-select"
      isMulti={true}
      closeMenuOnSelect={false}
      controlShouldRenderValue={false}
      className={classes.select}
      styles={style}
      blurInputOnSelect={false}
      onChange={(newValue, actionMeta) => {
        if (
          ["select-option", "deselect-option"].indexOf(actionMeta.action) !==
            -1 &&
          countriesMap
        ) {
          // @ts-ignore
          handleToggleCountry(countriesMap?.[actionMeta.option.value]);
        }
      }}
      components={components}
    />
  );
};
